<template>
  <Body>
    <LayoutAppNavBar
      v-if="layoutStore.isNavigationHeaderVisible"
      :languages="navBarItems.languages"
      :nav-items="navBarItems.navigationItems"
      :auth="{
        firstName: userStore.firstName,
        isAuthenticated,
        loginWithRedirect,
        logout: logoutHandler,
      }"
    />
    <main id="main-content">
      <div class="main-app">
        <div class="wrap">
          <h1>404!</h1>
          <p>Page not found!</p>
          <Button :href="localePath('/')"> Go to homepage </Button>
          <div v-if="!$isProd" v-html="error.stack" />
        </div>
      </div>
    </main>
  </Body>
</template>

<script setup lang="ts">
/**
 * This template has been cleaned up drastically and lacks some necessary content now.
 * Please note that the error page will be addressed in https://citizenm.atlassian.net/browse/FOJO-2791
 */
import type { NuxtError } from "#app";

const { error } = defineProps<{
  error: NuxtError;
}>();

const { locale } = useI18n();
useHead({
  htmlAttrs: {
    lang: locale.value,
  },
});

const localePath = useLocalePath();
const { track404 } = useTracking();
const userStore = useUserStore();
const { $auth } = useNuxtApp();
const { logout, isAuthenticated, loginWithRedirect } = $auth;
const layoutStore = useLayoutStore();

const { setHotels } = useHotels();
const { data } = await useFetch<PropertyHotel[]>("/api/v2/properties/hotels", {
  query: { locale },
});
setHotels(data);

const { navBarItems } = await useNavigationItems();

function logoutHandler() {
  if (import.meta.client) {
    // Clear redfast data on explicit user logout
    localStorage.removeItem("redfast-id");
    localStorage.removeItem("redfast-user-email");

    userStore.logoutUser();
    logout({
      logoutParams: {
        returnTo: window.location.origin + localePath("/"), // Go to homepage with a message
      },
    });
  }
}

if (import.meta.client && error.statusCode === 404) {
  track404();
}
</script>

<style lang="scss" scoped>
.shadow {
  box-shadow: var(--shadow);
  transition: 0.3s;
}

#main-content {
  min-height: 95vh;
}
</style>
